import React from "react";
import ReactECharts from 'echarts-for-react';
import { isMobileView, chartLegendIcon, getDOMTextWidth } from "../../utils/Reusables";

export default function PieChart(props) {
  let { resultSet, COLORS_SERIES, isLegendVisible, dateFieldFormat, handleCategoryData, columnTitle, legendPosition, pivotConfig, columnDisplayName, settings,timeDimensionDateFormat } = props;
  const seriesData = handleCategoryData(resultSet, dateFieldFormat, pivotConfig,timeDimensionDateFormat);
  if(seriesData?.categories?.length) {
    seriesData.categories = seriesData?.categories?.filter(n => n);
  }

  const [chartWidth, setChartWidth] = React.useState(null);
  const [chartHeight, setChartHeight] = React.useState(300);
  const [echartRef, setEchartRef] = React.useState(null);
  const [echartInstance, setEchartInstance] = React.useState(null);

  const chartParentRef = React.useRef(null);
  const [legendHeight, setLegendHeight] = React.useState(30);

  React.useEffect(() => {
    if(echartRef) {
      setChartWidth(echartRef.ele.clientWidth - 20);
      setEchartInstance(echartRef.getEchartsInstance());
    } 
}, [echartRef]);

React.useEffect(() => {
  handleChartHeight()
}, [legendHeight, legendPosition, isLegendVisible, settings]);

React.useEffect(() => {
  handleChartDimensions();
}, [chartParentRef, isLegendVisible, legendPosition, settings]);

const handleChartHeight = () => {
  if(isLegendVisible) {
    if(isMobileView()) {
      if(settings?.mobile?.legendPagination) {
        setChartHeight(300);
      } else {
        if(legendPosition === 'top' || legendPosition === 'bottom'){
          setChartHeight(legendHeight + 270);
        } else {
          setChartHeight(300);
        }
      }

    } else {

      if( settings?.web?.legendPagination) {
        setChartHeight(300);
      } else {
        if(legendPosition === 'right' || legendPosition === 'left') {
          setChartHeight(300); 
        } else {
          setChartHeight(legendHeight + 270); 
          console.log("CHH",legendHeight + 270 )
        }
      }

    }
  } else {
    setChartHeight(300);
  }
}

const handleChartDimensions = () => {
  if(isLegendVisible) {
    let isLegendPagination = isMobileView() ? settings?.mobile?.legendPagination : settings?.web?.legendPagination
    if(isLegendPagination) {
      setLegendHeight(30);
    } else {
      let maxLabelValues = seriesData?.categories?.map(label => {
        if (settings?.mobile?.truncateLabel) {
          if (!settings?.mobile?.maxLabelCharacters && settings?.mobile?.maxLabelCharacters) {
            return label?.substring(0, Number(settings?.mobile?.maxLabelCharacters)) + '...';
          }
          return label;
        }
      });
      let labelLengths = maxLabelValues?.map(label => {
        return getDOMTextWidth(label, '12px sans-serif')
      })
    
      var legendWidth = (labelLengths.reduce((a, b) => a + b, 0) + (45 * labelLengths?.length));
      if(chartParentRef?.current?.clientWidth && legendWidth){
        let totalLegendHeight = 32 * Math.ceil(legendWidth/chartParentRef?.current?.clientWidth) + (isMobileView() ? ((seriesData?.categories?.length/20)*32) : 32);
        setLegendHeight(totalLegendHeight);
        console.log("LH", totalLegendHeight)
      }
    }
  } else {
    setLegendHeight(0);
  }
  
}

  let alignmentType = ''
  let alignmentValue = ''

  switch (legendPosition) {
    case 'right':
      alignmentType = 'right'
      alignmentValue = 15
      break;
    case 'bottom':
      alignmentType = 'bottom'
      alignmentValue = 20
      break;
    case 'top':
      alignmentType = 'top'
      alignmentValue = legendHeight
      break;
    case 'left':
      alignmentType = 'left'
      alignmentValue = 80
      break;
  }


  const series = resultSet.series(pivotConfig).map((s, index) => ({
    name: handleChartLabel(columnTitle, columnDisplayName, s),
    type: 'pie',
    center: ['50%', '50%'],
    [alignmentType]: alignmentValue,
    data: s.series.map((r, i) => ({ value: (r?.value === undefined || r?.value === null || r?.value === 'NaN') ? 0 : r?.value, name: seriesData?.categories[i] || r.x })),
    avoidLabelOverlap: true,
    height: (legendPosition === 'top' || legendPosition === 'bottom') ? '270px' : '300px',
    label: {
      show: isMobileView() ? settings?.mobile?.showXaxisLabel : settings?.web?.showXaxisLabel,
      lineHeight: 16,
      formatter: function (name) {
        if (settings?.web?.showXaxisLabel && settings?.web?.truncateLabel && !isMobileView()) {
          if (!settings?.web?.maxLabelCharacters) {
            return name?.name
          }
          return name?.name?.substring(0, Number(settings?.web?.maxLabelCharacters)) + '...'
        }

        if (settings?.mobile?.showXaxisLabel && settings?.mobile?.truncateLabel && isMobileView()) {
          if (!settings?.mobile?.maxLabelCharacters) {
            return name?.name
          }
          return name?.name?.substring(0, Number(settings?.mobile?.maxLabelCharacters)) + '...'
        }

        return name?.name
      }
    },
  }))

  const legendWidthForTopBottomPositions = () => {
    var legendValues = seriesData?.categories?.filter(n => n);
      let legendLabelsCount;
      if(!isMobileView() && settings?.web?.legendPagination && settings?.web?.maxLegendsCount){
        legendLabelsCount = settings?.web?.maxLegendsCount
      } else if(isMobileView() && settings?.mobile?.legendPagination && settings?.mobile?.maxLegendsCount) {
        legendLabelsCount = settings?.mobile?.maxLegendsCount
      } else {
        return null;
      }
      
      let maxLabelValues = legendValues?.slice(0, legendLabelsCount);
      let labelLengthsWeb = maxLabelValues?.map(label => {
        return getDOMTextWidth(label, '12px sans-serif')
      })
      
      let legendWidth = (labelLengthsWeb.reduce((a, b) => a + b, 0) + (45 * labelLengthsWeb?.length));
      return legendWidth + 55;
  }


  let legend = {}
  let legendWidth;
  switch (legendPosition) {
    case 'right':
      legend = {
        orient: 'vertical',
        left: 'right',
        top: 0,
        type: 'scroll',
        show: isLegendVisible,
        itemHeight: 20,
        textStyle: {
          width: 80,
          overflow: "truncate",
          fontSize: 12,
          lineHeight: 20,
        },
        icon: chartLegendIcon()
      }


      if (settings?.web?.legendPagination && settings?.web?.maxLegendsCount && !isMobileView()) {
        legend.height = Number(settings?.web?.maxLegendsCount) * 30 + 24
      }
      else if (settings?.mobile?.legendPagination && settings?.mobile?.maxLegendsCount && isMobileView()) {
        legend.height = Number(settings?.mobile?.maxLegendsCount) * 30 + 24
      }
      else {
        delete legend?.height
      }

      break;
    case 'bottom':
      legend = {
        orient: 'horizontal',
        bottom: 0,
        left: '10px',
        type: isMobileView() ? (settings?.mobile?.legendPagination ? 'scroll' : 'plain') : (settings?.web?.legendPagination ? 'scroll' : 'plain'),
        show: isLegendVisible,
        itemHeight: 20,
        textStyle: {
          // width: 80,
          // overflow: "truncate",
          fontSize: 12,
          lineHeight: 20,
        },
        icon: chartLegendIcon()
      }

      legendWidth = legendWidthForTopBottomPositions();
      if(legendWidth) {
        legend.width = legendWidth;
      } else {
        delete legend?.width;
      }

      break;
    case 'top':
      legend = {
        orient: 'horizontal',
        top: -6,
        left: '10px',
        type: isMobileView() ? (settings?.mobile?.legendPagination ? 'scroll' : 'plain') : (settings?.web?.legendPagination ? 'scroll' : 'plain'),
        show: isLegendVisible,
        itemHeight: 20,
        textStyle: {
          // width: 80,
          // overflow: "truncate",
          fontSize: 12,
          lineHeight: 20,
        },
        icon: chartLegendIcon(),
      }

      legendWidth = legendWidthForTopBottomPositions();
      if(legendWidth) {
        legend.width = legendWidth;
      } else {
        delete legend?.width;
      }

      break;
    case 'left':
      legend = {
        orient: 'vertical',
        left: 'left',
        top: 0,
        type: 'scroll',
        show: isLegendVisible,
        itemHeight: 20,
        textStyle: {
          width: 80,
          overflow: "truncate",
          fontSize: 12,
          lineHeight: 20,
        },
        icon: chartLegendIcon(),
      }

      if (settings?.web?.legendPagination && settings?.web?.maxLegendsCount && !isMobileView()) {
        legend.height = Number(settings?.web?.maxLegendsCount) * 30 + 24
      }
      else if (settings?.mobile?.legendPagination && settings?.mobile?.maxLegendsCount && isMobileView()) {
        legend.height = Number(settings?.mobile?.maxLegendsCount) * 30 + 24
      }
      else {
        delete legend?.height
      }

      break;
  }

  let options = {
    tooltip: {
      trigger: 'item',
      triggerOn: isMobileView() ? 'click' : 'mousemove|click',
      confine: true,
      borderWidth: '0',
    },
    legend,
    series,
    color: COLORS_SERIES,
    avoidLabelOverlap: true,
  };

  // if (isLegendVisible && (legendPosition === 'right' || legendPosition === 'left')) {
  //   options.width = '85%'
  // }
  // else if (isLegendVisible && (legendPosition === 'bottom' || legendPosition === 'top')) {
  //   options.height = '90%'
  // }

  console.log("CH", chartHeight, options)
  return (
    <div className={'chart-parent'} ref={chartParentRef} style={{marginRight: '10px'}} >
      <ReactECharts 
        style={{
          height: chartHeight + 'px', 
          width: '100%'
        }} 
        option={options} 
        opts={{ renderer: 'svg' }}
        ref={(e) => {setEchartRef(e)}}
      />
    </div>
  )
}


const handleChartLabel = (columnTitle, columnDisplayName, s) => {
  let label;
  if (columnTitle && columnTitle.length && columnTitle[0][s?.key]) {
    label = columnTitle[0][s?.key]
  }
  else if (columnDisplayName && columnDisplayName[s?.key]) {
    label = columnDisplayName[s?.key]
  }
  else if (s?.key && columnDisplayName && Object.keys(columnDisplayName).length) {
    Object.keys(columnDisplayName).forEach(col => {
      if (s?.key.includes(col)) {
        s.key = s?.key.replace(col, columnDisplayName[col]);
        label = s?.key;
      }
      else {
        label = s?.title
      }
    })
  }
  else {
    label = s?.title
  }

  return label;
}